import { Search, X, FileSpreadsheet, FileDown } from "lucide-react";
import { Input } from "../ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { CATEGORIES, SENTIMENTS, STATUSES } from "../../lib/constants";

const Pick = ({ value, onChange, testId, all, options }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger data-testid={testId} className="h-10 w-full sm:w-[150px] rounded-full bg-white/90 text-sm"><SelectValue /></SelectTrigger>
    <SelectContent className="bg-white">
      <SelectItem value="All">{all}</SelectItem>
      {options.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}
    </SelectContent>
  </Select>
);

export const EMPTY_FILTERS = { q: "", category: "All", rating: "All", sentiment: "All", status: "All", date_from: "", date_to: "" };

export const FiltersBar = ({ f, set, onExport, exporting }) => {
  const dirty = JSON.stringify(f) !== JSON.stringify(EMPTY_FILTERS);
  return (
    <div className="glass rounded-3xl p-4 flex flex-wrap items-center gap-2" data-testid="filters-bar">
      <div className="relative w-full lg:w-72">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
        <Input data-testid="filter-search-input" value={f.q} onChange={(e) => set({ q: e.target.value })} placeholder="Search guest, keyword, topic…" className="h-10 pl-9 rounded-full bg-white/90" />
      </div>
      <Pick testId="filter-category" value={f.category} onChange={(v) => set({ category: v })} all="All categories" options={CATEGORIES.map((c) => [c, c])} />
      <Pick testId="filter-rating" value={f.rating} onChange={(v) => set({ rating: v })} all="All ratings" options={[["critical", "Critical (1–2)"], ...[5, 4, 3, 2, 1].map((r) => [String(r), `${r} star`])]} />
      <Pick testId="filter-sentiment" value={f.sentiment} onChange={(v) => set({ sentiment: v })} all="All sentiment" options={SENTIMENTS.map((s) => [s, s])} />
      <Pick testId="filter-status" value={f.status} onChange={(v) => set({ status: v })} all="All statuses" options={STATUSES.map((s) => [s, s])} />
      <div className="flex items-center gap-1 rounded-full bg-white/90 border border-input px-3 h-10">
        <input data-testid="filter-date-from" type="date" value={f.date_from} onChange={(e) => set({ date_from: e.target.value })} className="bg-transparent text-sm outline-none w-[120px]" />
        <span className="text-slate-400 text-xs">to</span>
        <input data-testid="filter-date-to" type="date" value={f.date_to} onChange={(e) => set({ date_to: e.target.value })} className="bg-transparent text-sm outline-none w-[120px]" />
      </div>
      {dirty && (
        <button data-testid="filter-clear-button" onClick={() => set(EMPTY_FILTERS)} className="h-10 px-3 rounded-full text-sm font-semibold text-slate-600 hover:bg-slate-100 flex items-center gap-1 transition-colors">
          <X className="h-4 w-4" /> Clear
        </button>
      )}
      <div className="ml-auto flex gap-2">
        <button data-testid="export-csv-button" disabled={exporting} onClick={() => onExport("csv")} className="h-10 px-4 rounded-full border border-emerald-900/20 bg-white text-emerald-900 text-sm font-semibold hover:bg-emerald-50 flex items-center gap-2 transition-colors disabled:opacity-50">
          <FileDown className="h-4 w-4" /> CSV
        </button>
        <button data-testid="export-excel-button" disabled={exporting} onClick={() => onExport("xlsx")} className="h-10 px-4 rounded-full bg-emerald-900 text-amber-50 text-sm font-semibold hover:bg-emerald-800 flex items-center gap-2 transition-colors disabled:opacity-50">
          <FileSpreadsheet className="h-4 w-4" /> Excel
        </button>
      </div>
    </div>
  );
};
